mutation ObtainBadgeMutation($input: ObtainBadgeInput!) {
  obtainBadge(input: $input) {
    user {
      id
      badges {
        number
        isOwned
        receivedAt
      }
    }
  }
}
